export default __webpack_public_path__ + "static/media/rfq-proyek.2cab93b1.png";